import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Mail, Phone, MapPin, Recycle } from 'lucide-react';
import { companyInfo } from '../mock';

export const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-gradient-to-br from-neutral-900 via-neutral-800 to-neutral-900 text-neutral-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12 lg:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="col-span-2 md:col-span-1 space-y-4 sm:space-y-5">
            <div className="flex items-center space-x-2 sm:space-x-3">
              <div className="flex h-9 w-9 sm:h-11 sm:w-11 items-center justify-center rounded-xl bg-gradient-to-br from-emerald-500 to-teal-600 shadow-lg">
                <span className="!font-bold text-base sm:!text-xl text-white">{t('company.name')}</span>
              </div>
              <span className="!font-semibold text-base sm:!text-lg text-white">{t('company.name')}</span>
            </div>
            <p className="text-xs sm:text-sm leading-relaxed text-neutral-400">
              {t('footer.description')}
            </p>
            <div className="flex items-center space-x-2 text-emerald-400">
              <Recycle size={16} />
              <span className="text-xs font-medium">{t('footer.recyclable')}</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-white mb-3 sm:mb-5 text-sm sm:text-base lg:text-lg">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2 sm:space-y-3 text-xs sm:text-sm">
              <li><Link to="/products" className="text-neutral-400 hover:text-emerald-400 transition-colors">{t('nav.products')}</Link></li>
              <li><Link to="/applications" className="text-neutral-400 hover:text-emerald-400 transition-colors">{t('nav.applications')}</Link></li>
              <li><Link to="/sustainability" className="text-neutral-400 hover:text-emerald-400 transition-colors">{t('nav.sustainability')}</Link></li>
              <li><Link to="/about" className="text-neutral-400 hover:text-emerald-400 transition-colors">{t('nav.about')}</Link></li>
              <li><Link to="/contact" className="text-neutral-400 hover:text-emerald-400 transition-colors">{t('nav.contact')}</Link></li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="font-semibold text-white mb-3 sm:mb-5 text-sm sm:text-base lg:text-lg">{t('nav.products')}</h3>
            <ul className="space-y-2 sm:space-y-3 text-xs sm:text-sm">
              <li><Link to={`/products/1`}>60L Bins</Link></li>
              <li><Link to={`/products/2`}>90L Bins</Link></li>
              <li><Link to={`/products/3`}>120L Bins</Link></li>
              <li><Link to={`/products/4`}>240L Bins</Link></li>
              <li><Link to={`/products/5`}>660L Bins</Link></li>
              
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-2 md:col-span-1">
            <h3 className="font-semibold text-white mb-3 sm:mb-5 text-sm sm:text-base lg:text-lg">{t('footer.contactUs')}</h3>
            <ul className="space-y-3 sm:space-y-4 text-xs sm:text-sm">
              <li className="flex items-start space-x-2 sm:space-x-3">
                <Mail size={16} className="mt-0.5 text-emerald-400 flex-shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="text-neutral-400 hover:text-emerald-400 transition-colors break-all">
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-start space-x-2 sm:space-x-3">
                <Phone size={16} className="mt-0.5 text-emerald-400 flex-shrink-0" />
                <a href={`tel:${companyInfo.phone}`} className="text-neutral-400 hover:text-emerald-400 transition-colors">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-start space-x-2 sm:space-x-3">
                <MapPin size={16} className="mt-0.5 text-emerald-400 flex-shrink-0" />
                <span className="text-neutral-400">{companyInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-neutral-800 mt-8 sm:mt-10 lg:mt-12 pt-6 sm:pt-8 text-center text-xs sm:text-sm">
          <p className="text-neutral-500">&copy; {new Date().getFullYear()} {t('company.fullName')}. {t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
};